import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import { getTwitterHandle } from '../../../../catalog/Social';

const TitleAndDescriptionTags = (props) => {
    const { title, pageTitle, description, keywords } = props;
    const { globalState } = useContext(context);

    return (
        <Helmet>
            {isValidString(title) ? (<title>{title}</title>) : null}
            {isValidString(description) ? (<meta name="description" content={description} />) : null}
            {isValidString(keywords) ? (<meta name="keywords" content={keywords} />) : null}

            {isValidString(pageTitle) ? (
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "${pageTitle}"
                            }]
                        }
                    `}
                </script>
            ) : null}

            {isValidString(title) ? (<meta name="twitter:title" content={title} />) : null}
            {isValidString(description) ? (<meta name="twitter:description" content={description} />) : null}
            {isValidObject(globalState) && isValidObject(globalState.socials) && isValidString(globalState.socials.twitterURL) ? (<meta name="twitter:site" content={`@${getTwitterHandle(globalState.socials.twitterURL)}`} />) : null}

            {isValidString(title) ? (<meta property="og:title" content={title} />) : null}
            {isValidString(description) ? (<meta property="og:description" content={description} />) : null}
        </Helmet>
    );
};

TitleAndDescriptionTags.propTypes = {
    title: PropTypes.string.isRequired,
    pageTitle: PropTypes.string,
    description: PropTypes.string.isRequired,
    keywords: PropTypes.string.isRequired,
};

TitleAndDescriptionTags.defaultProps = {
    pageTitle: '',
};

export default memo(TitleAndDescriptionTags);
